
import { SEO } from '../../../utils/seo';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import PropertyTypesSection from './components/PropertyTypesSection';
import BenefitsSection from './components/BenefitsSection';
import ProcessSection from './components/ProcessSection';
import WaitlistFormSection from './components/WaitlistFormSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '../../../components/feature/Footer';
import GlobalNavbar from '../../../components/feature/GlobalNavbar';

export default function RentHousesApartmentsPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Rent Houses & Apartments El Paso | TREX RE LLC Rental Properties"
        description="Looking to rent a house or apartment in El Paso? TREX RE LLC offers quality rental properties including houses, duplexes, and apartments. Flexible credit options and responsive service."
        keywords="rent house El Paso, apartments for rent El Paso, rental properties El Paso, houses for rent, TREX RE LLC rentals"
        canonical="/rental-property/rent-houses-apartments"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Rental Properties",
          "provider": {
            "@type": "RealEstateAgent",
            "name": "TREX RE LLC"
          },
          "areaServed": "El Paso, TX"
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <IntroSection />
      <PropertyTypesSection />
      <BenefitsSection />
      <ProcessSection />
      <WaitlistFormSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
